import axios from 'axios'

export default {
  addNewDevice: (app, key) => axios.put(`/api/v1/bhs/cms/init/signage?appName=${app}&sixDigitsKey=${key}`),
  deleteDevice: mac => axios.delete(`/api/v1/bhs/cms/init/signage/${mac}`),
  getAllDevices: () => axios.get('/api/v1/bhs/cms/init/signage'),
  setAppTmp: (mac, appTmp) => axios.put(`/api/v1/bhs/cms/init/signage/appTmp?appTmp=${appTmp}&mac=${mac}`)
}
